var AR = require('component/core/core.js');

function initCharts(callback) {
	require.ensure(['zebra-charts', './charts.json'], function (require) {
		var ZebraCharts = require('zebra-charts');
		var zebraCharts = new ZebraCharts(AR.lang);
		var charts = require('./charts.json');
		global.zebraCharts = zebraCharts;
		zebraCharts.makeCharts(charts, callback);
	});
}

var chartElements = $('.chart');
if (chartElements.length > 0) {
	initCharts(function () {
		$('.graphic').each(function (index, el) {
			var $this = $(this);

			if ($this.find('.chart').length) {
				$this.addExcelExport();
			}
		});

	});
}



/** WEBPACK FOOTER **
 ** ./frontend/components/charts/charts.js
 **/